var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: _vm.maskContainer, attrs: { id: "vue-picture-viewer" } },
    [
      _c("div", { staticClass: "perview-header" }, [
        _c("span", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "imgContainer",
          staticClass: "imgContainer",
          style: _vm.imgContainer,
        },
        [
          _vm.bigShowType.isImage
            ? _c("img", {
                directives: [
                  {
                    name: "src",
                    rawName: "v-src",
                    value: _vm.bigImgUrl,
                    expression: "bigImgUrl",
                  },
                ],
                ref: "bigImg",
                style: _vm.bigImgStyle,
                attrs: { alt: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.bigShowType.isImage
            ? _c("div", { staticClass: "file-show" }, [
                !_vm.showPreviewBtn
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v("该附件格式不支持预览，请下载后查看"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-close",
                  on: { click: _vm.closeViewer },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "content" }, [
                  _c("img", {
                    staticClass: "file-icon",
                    attrs: { src: _vm.bigShowType.icon },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "file-handle" },
                    [
                      _vm.showPreviewBtn
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", plain: "" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.previewFile.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("预览")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.downloadFile.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTips,
                    expression: "showTips",
                  },
                ],
                staticClass: "tips",
              },
              [_vm._v(_vm._s(_vm.tipsText))]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fixedHandle" },
        [
          _vm.bigShowType.isImage
            ? _c("flexbox", { staticClass: "handleContainer" }, [
                _c("div", { staticClass: "handle-box" }, [
                  _c("i", {
                    staticClass: "wk wk-zoom-in",
                    on: { click: _vm.enlarge },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "wk wk-zoom-on",
                    on: { click: _vm.reduce },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "wk wk-rotate",
                    on: { click: _vm.rotate },
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "wk wk-download",
                    on: { click: _vm.downloadFile },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "icon-btn", on: { click: _vm.closeViewer } },
                  [_c("i", { staticClass: "el-icon-close" })]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.imgLength > 1
            ? _c("div", { staticClass: "thumbnailContainer" }, [
                _c(
                  "ul",
                  _vm._l(_vm.imgData, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        ref: "thumbnailItem",
                        refInFor: true,
                        on: {
                          click: function ($event) {
                            return _vm.switchImgUrl(index, $event)
                          },
                        },
                      },
                      [
                        _vm.isShowImage(item.name)
                          ? _c("img", {
                              directives: [
                                {
                                  name: "src",
                                  rawName: "v-src",
                                  value: item.url,
                                  expression: "item.url",
                                },
                              ],
                              attrs: { alt: "" },
                            })
                          : _c("img", {
                              attrs: {
                                src: _vm.getFileTypeIconWithSuffix(item.name),
                                alt: "",
                              },
                            }),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "leftArrowCon",
          on: {
            click: _vm.handlePrev,
            mouseenter: _vm.enterLeft,
            mouseout: _vm.outLeft,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.leftArrowShow,
                  expression: "leftArrowShow",
                },
              ],
              staticClass: "icon-btn leftArrow",
            },
            [_c("i", { staticClass: "el-icon-arrow-left" })]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rightArrowCon",
          on: {
            click: _vm.handleNext,
            mouseenter: _vm.enterRight,
            mouseout: _vm.outRight,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.rightArrowShow,
                  expression: "rightArrowShow",
                },
              ],
              staticClass: "icon-btn rightArrow",
            },
            [_c("i", { staticClass: "el-icon-arrow-right" })]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }